export const UserPermissionEnum = Object.freeze({
    // Permissions to edit users within your own organisation
    USER_CREATE: 'USER_CREATE',
    USER_READ: 'USER_READ',
    USER_UPDATE: 'USER_UPDATE',
    USER_DELETE: 'USER_DELETE'
});

export const ClientUserPermissionEnum = Object.freeze({
    // Permissions to manage users within your client investors
    CLIENT_USER_CREATE: 'CLIENT_USER_CREATE',
    CLIENT_USER_READ: 'CLIENT_USER_READ',
    CLIENT_USER_UPDATE: 'CLIENT_USER_UPDATE',
    CLIENT_USER_DELETE: 'CLIENT_USER_DELETE'
});

export const OrganisationPermissionEnum = Object.freeze({
    // Organisation Permissions
    ORGANISATION_READ: 'ORGANISATION_READ',
    ORGANISATION_UPDATE: 'ORGANISATION_UPDATE',
    ORGANISATION_BILLING: 'ORGANISATION_BILLING'
});

export const InvestmentPermissionEnum = Object.freeze({
    // Investment Permissions
    INVESTMENT_BOOK: 'INVESTMENT_BOOK'
});

export const TransactionPermissionEnum = Object.freeze({
    // Transaction Permissions
    TRANSACTION_CREATE: 'TRANSACTION_CREATE',
    TRANSACTION_READ: 'TRANSACTION_READ',
    TRANSACTION_UPDATE: 'TRANSACTION_UPDATE',
    TRANSACTION_LIMITED_UPDATE: 'TRANSACTION_LIMITED_UPDATE',
    TRANSACTION_CANCEL: 'TRANSACTION_CANCEL'
});

export const ReportPermissionEnum = Object.freeze({
    // Report Permissions
    REPORT_CREATE: 'REPORT_CREATE',
    REPORT_READ: 'REPORT_READ',
    REPORT_UPDATE: 'REPORT_UPDATE',
    REPORT_DELETE: 'REPORT_DELETE'
});

export const AssetPermissionEnum = Object.freeze({
    // Holding Permissions (aliased as Asset)
    ASSET_CREATE: 'ASSET_CREATE',
    ASSET_READ: 'ASSET_READ',
    ASSET_UPDATE: 'ASSET_UPDATE',
    ASSET_DELETE: 'ASSET_DELETE',
    ASSET_MERGE: 'ASSET_MERGE'
});

export const AssetValuePermissionEnum = Object.freeze({
    // Holding value Permissions
    ASSET_VALUE_CREATE: 'ASSET_VALUE_CREATE',
    ASSET_VALUE_UPDATE: 'ASSET_VALUE_UPDATE',
    ASSET_VALUE_DELETE: 'ASSET_VALUE_DELETE'
});

export const ChildUserPermissionEnum = Object.freeze({
    // Child user permissions
    CHILD_USER_CREATE: 'CHILD_USER_CREATE',
    CHILD_USER_READ: 'CHILD_USER_READ',
    CHILD_USER_UPDATE: 'CHILD_USER_UPDATE',
    CHILD_USER_DELETE: 'CHILD_USER_DELETE'
});

export const AdviserPermissionEnum = Object.freeze({
    // Adviser Permissions
    ADVISER_CREATE: 'ADVISER_CREATE',
    ADVISER_READ: 'ADVISER_READ',
    ADVISER_UPDATE: 'ADVISER_UPDATE',
    ADVISER_DELETE: 'ADVISER_DELETE'
});

export const InvestorPermissionEnum = Object.freeze({
    // Investor Permissions
    INVESTOR_CREATE: 'INVESTOR_CREATE',
    INVESTOR_READ: 'INVESTOR_READ',
    INVESTOR_UPDATE: 'INVESTOR_UPDATE',
    INVESTOR_ASSIGN: 'INVESTOR_ASSIGN'
});

export const ProductPermissionEnum = Object.freeze({
    // Product Permissions
    PRODUCT_CREATE: 'PRODUCT_CREATE',
    PRODUCT_READ: 'PRODUCT_READ',
    PRODUCT_UPDATE: 'PRODUCT_UPDATE',
    PRODUCT_DELETE: 'PRODUCT_DELETE',
    PRODUCT_REVIEW: 'PRODUCT_REVIEW',
    PRODUCT_APPROVE: 'PRODUCT_APPROVE'
});

export const OfferPermissionEnum = Object.freeze({
    // Offer Permissions
    OFFER_CREATE: 'OFFER_CREATE',
    OFFER_READ: 'OFFER_READ',
    OFFER_DELETE: 'OFFER_DELETE',
    OFFER_UPDATE: 'OFFER_UPDATE',
    OFFER_REVIEW: 'OFFER_REVIEW',
    OFFER_APPROVE: 'OFFER_APPROVE'
});

export const DisclosurePermissionEnum = Object.freeze({
    // Disclosure Permissions
    DISCLOSURE_CREATE: 'DISCLOSURE_CREATE',
    DISCLOSURE_READ: 'DISCLOSURE_READ',
    DISCLOSURE_UPDATE: 'DISCLOSURE_UPDATE',
    DISCLOSURE_DELETE: 'DISCLOSURE_DELETE'
});

export const AnyOrganisationPermissionEnum = Object.freeze({
    // Any-organisation permissions
    ANY_ORGANISATION_CREATE: 'ANY_ORGANISATION_CREATE',
    ANY_ORGANISATION_READ: 'ANY_ORGANISATION_READ',
    ANY_ORGANISATION_UPDATE: 'ANY_ORGANISATION_UPDATE',
    ANY_ORGANISATION_DELETE: 'ANY_ORGANISATION_DELETE'
});

export const AnyUserPermissionEnum = Object.freeze({
    // Any-user permissions - applies to a user in any other organisation other than my own.
    ANY_USER_CREATE: 'ANY_USER_CREATE',
    ANY_USER_READ: 'ANY_USER_READ',
    ANY_USER_UPDATE: 'ANY_USER_UPDATE',
    ANY_USER_DELETE: 'ANY_USER_DELETE'
});

export const BulkPermissionEnum = Object.freeze({
    // Import/export permissions
    BULK_IMPORT: 'BULK_IMPORT',
    BULK_EXPORT: 'BULK_EXPORT'
});

export const RegistrationPermissionEnum = Object.freeze({
    // registration
    ANY_REGISTRATION_READ: 'ANY_REGISTRATION_READ',
    APPROVE_REGISTRATION: 'APPROVE_REGISTRATION'
});

export const InvestorVisibilityGroupPermissionEnum = Object.freeze({
    // Investor Visibility Group Permissions
    IVG_CREATE: 'IVG_CREATE',
    IVG_READ: 'IVG_READ',
    IVG_UPDATE: 'IVG_UPDATE',
    IVG_DELETE: 'IVG_DELETE'
});

export const HoldingPermissionEnum = Object.freeze({
    // holding
    HOLDING_ALLOT: 'HOLDING_ALLOT'
});

export const TermsPermissionEnum = Object.freeze({
    // Terms and Conditions
    TERMS_CREATE: 'TERMS_CREATE',
    TERMS_READ: 'TERMS_READ',
    TERMS_UPDATE: 'TERMS_UPDATE',
    TERMS_DELETE: 'TERMS_DELETE'
});

export const ShareValuationPermissionEnum = Object.freeze({
    // Share Valuation Permissions
    SHARE_VALUATION_CREATE: 'SHARE_VALUATION_CREATE',
    SHARE_VALUATION_READ: 'SHARE_VALUATION_READ',
    SHARE_VALUATION_UPDATE: 'SHARE_VALUATION_UPDATE',
    SHARE_VALUATION_DELETE: 'SHARE_VALUATION_DELETE'
});

export const MiscPermissionEnum = Object.freeze({
    // Misc permissions
    PAYMENT_RUN_CREATE: 'PAYMENT_RUN_CREATE',
    INSTRUCTION_APPROVE: 'INSTRUCTION_APPROVE',
    EMULATE_ANY_USER: 'EMULATE_ANY_USER',
    MANAGE_INVESTING_WORKFLOW: 'MANAGE_INVESTING_WORKFLOW',
    ACTIVITY_CUSTOM_CREATE: 'ACTIVITY_CUSTOM_CREATE'
});

export const PermissionEnum = Object.freeze({
    ...UserPermissionEnum,
    ...ClientUserPermissionEnum,
    ...OrganisationPermissionEnum,
    ...InvestmentPermissionEnum,
    ...TransactionPermissionEnum,
    ...ReportPermissionEnum,
    ...AssetPermissionEnum,
    ...AssetValuePermissionEnum,
    ...ChildUserPermissionEnum,
    ...AdviserPermissionEnum,
    ...InvestorPermissionEnum,
    ...ProductPermissionEnum,
    ...OfferPermissionEnum,
    ...DisclosurePermissionEnum,
    ...AnyOrganisationPermissionEnum,
    ...AnyUserPermissionEnum,
    ...BulkPermissionEnum,
    ...RegistrationPermissionEnum,
    ...InvestorVisibilityGroupPermissionEnum,
    ...HoldingPermissionEnum,
    ...TermsPermissionEnum,
    ...ShareValuationPermissionEnum,
    ...MiscPermissionEnum
});

export default PermissionEnum;
